import { SearchQuery } from 'storefront-query-builder'
import { Module } from 'vuex'
import { quickSearchByQuery } from '@vue-storefront/core/lib/search'
import { isServer } from '@vue-storefront/core/helpers'

import RootState from '@vue-storefront/core/types/RootState'
import ConfigState from '../types/ConfigState'
import Vue from 'vue'

/** Per-worker SSR cache — Magento store config changes rarely. */
let ssrConfigCache: { items: unknown[]; loadedAt: number } | null = null
const SSR_CONFIG_TTL_MS = 15 * 60 * 1000

export const configStore: Module<ConfigState, RootState> = {
  namespaced: true,
  state: {
    config: []
  },
  mutations: {
    setConfigValues (state, configValues) {
      state.config = configValues || []
    }
  },
  getters: {
    getConfigValue: (state) => (path) => {
      if (!state.config) {
        return null
      }
      const value = state.config.find(p => p.config_path === path)
      if (value) {
        return value.config_value
      }
    }
  },
  actions: {
    async loadConfigData ({ commit, state }) {
      if (state.config && state.config.length > 0) {
        return
      }
      if (
        isServer &&
        ssrConfigCache &&
        Date.now() - ssrConfigCache.loadedAt < SSR_CONFIG_TTL_MS
      ) {
        commit('setConfigValues', ssrConfigCache.items)
        return
      }

      const query = new SearchQuery()

      const response = await quickSearchByQuery({ entityType: 'config', query })
      if (response) {
        const items = response.items
        commit('setConfigValues', items)
        if (isServer) {
          ssrConfigCache = { items, loadedAt: Date.now() }
        }
      }
    }
  }
}
